export default __webpack_public_path__ + "static/media/pending.ba7b2c42.png";